module.exports = __webpack_public_path__ + "img/fileImg3.5493bf67.png";